// extracted by mini-css-extract-plugin
module.exports = {"button":"_2fjFd","buttonIcon":"_28Goz"};